import React, {useState} from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { Modal } from "react-bootstrap";
import {showModal,signUp} from "../../Slices/sessionSlice"
import {id as LoginModalId} from "../LogInModal/LogInModal"
import GoogleLoginButton from "../GoogleLoginButton/GoogleLoginButton";
import FacebookLoginButton from "../FacebookLoginButton/FacebookLoginButton";
export const id = "SignUp";

function SignUpModal() {

	const [state, setState] = useState({
		firstName: "",
		lastName: "",
    email: "",
    password: "",
		confirmPassword: "",
		agreeToPolicy: false,
  })
  const dispatch = useDispatch();
	// let history = useHistory();
  const {isEmailAlreadyExists} = useSelector((state) => state.sessionSlice.signUp);

  const onHide = () => {
    dispatch(showModal(null));
  }

	const { firstName, lastName, email, password, confirmPassword, agreeToPolicy } = state;

  return (
    <Modal size="lg" show={true} onHide={onHide}>
      <Modal.Header closeButton>
				<h3>Sign Up</h3>
			</Modal.Header>
      <Modal.Body>
        <div className="card login-card shadow">
          <div className="card-body">
            <div className="row">
              <div className="col-xs-6 col-lg-6">
                <label>First Name</label>
                <input
                  type="text"
                  className="form-control"
                  value={firstName}
                  name="firstName"
                  placeholder="Enter First Name..."
                  onChange={_handleInputChange}
                />
              </div>
              <div className="col-xs-6 col-lg-6">
                <label>Last Name</label>
                <input
                  type="text"
                  className="form-control"
                  value={lastName}
                  name="lastName"
                  placeholder="Enter Last Name..."
                  onChange={_handleInputChange}
                />
                {/* {this.renderValidationMessages('lastName')} */}
              </div>
            </div>
            <div className="row">
              <div className="col-xs-12 col-lg-12">
                <label>Email</label>
                <input
                  type="email"
                  className="form-control"
                  value={email}
                  name="email"
                  placeholder="Enter Email..."
                  // onBlur = {this._handleCheckEmailAvailability}
                  onChange={_handleInputChange}
                />
                {state.isEmailAlreadyExists && (
                  <div
                    style={{
                      display: "block",
                      marginBottom: "10px",
                      marginTop: "5px",
                      color: "#a94442",
                    }}
                  >
                    <div>
                      Email already exists. Please use log in or forgot
                      password.
                    </div>
                  </div>
                )}
              </div>
            </div>
            <div className="row">
              <div className="col-xs-6 col-lg-6">
                <label>Password</label>
                <input
                  type="password"
                  className="form-control"
                  value={password}
                  name="password"
                  placeholder="Enter Password..."
                  onChange={_handleInputChange}
                />
                {/* {this.renderValidationMessages('password')} */}
              </div>
              <div className="col-xs-6 col-lg-6">
                <label>Confirm Password</label>
                <input
                  type="password"
                  className="form-control"
                  value={confirmPassword}
                  name="confirmPassword"
                  placeholder="Enter Confirm Password..."
                  onChange={_handleInputChange}
                />
                {/* {this.renderValidationMessages('confirmPassword')} */}
              </div>
            </div>
            <div className="custom-checkbox mb-3">
              <label>
                <input
                  type="checkbox"
                  // className="custom-control-input"
                  name="agreeToPolicy"
                  defaultChecked={agreeToPolicy}
                  // value={agreeToPolicy}
                  onClick={() =>
                    setState({ ...state, agreeToPolicy: !agreeToPolicy })
                  }
                />
                <span className="ml-2">I agree to the</span>{" "}
                <a
                  href="https://mentorstudents.org/terms-and-conditions"
                  target="_blank"
                  rel="noreferrer"
                >
                  Terms of Use
                </a>{" "}
                and{" "}
                <a
                  href="https://mentorstudents.org/privacy-policy"
                  target="_blank"
                  rel="noreferrer"
                >
                  Privacy Policy
                </a>
              </label>
            </div>
            <div id="signUp">
            <button
              className="btn btn-success btn-block w-100"
              type="submit"
              onClick={_handleSubmit}
              disabled={
                !(
                  agreeToPolicy &&
                  firstName &&
                  email &&
                  password &&
                  confirmPassword &&
                  !isEmailAlreadyExists
                )
              }
            >
              Sign Up
            </button>
            </div>
            <br />
            <div id="signUp">
							<button className="btn btn-primary btn-block w-100" onClick={_handleLogIn}>Log In</button>
						</div>
            <div id="signUp">
              <GoogleLoginButton />
            </div>
            <div id="signUp">
              <FacebookLoginButton />
            </div>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );

	function _handleSubmit(event) {
		event.preventDefault();
    console.log("signup")
   	dispatch(signUp({email, password, firstName, lastName}));
	}

	function _handleInputChange(event){
    let value = event.target.value;
    if (event.target.name === 'agreeToPolicy') {
      value = !agreeToPolicy;
    }
    setState({
			...state,
      [event.target.name]: value,
    });
  };

	function _handleLogIn(){
		dispatch(showModal({id:LoginModalId,data:null}));
	}
}

export default SignUpModal;
